import { render, staticRenderFns } from "./app_main.vue?vue&type=template&id=4f47ad79&scoped=true"
import script from "./app_main.vue?vue&type=script&lang=js"
export * from "./app_main.vue?vue&type=script&lang=js"
import style0 from "./app_main.vue?vue&type=style&index=0&id=4f47ad79&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f47ad79",
  null
  
)

export default component.exports